module.exports = __webpack_public_path__ + "static/media/29ADMSPC28.4fda3af5.jpg";